"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_redux_1 = require("react-redux");
exports.Connect = function (name) {
    return (state, dispatch, render) => {
        const res = react_redux_1.connect(state, dispatch)(render);
        return res;
    };
};
//# sourceMappingURL=Connect.js.map


// WEBPACK FOOTER //
// ./node_modules/react-redux-pure/es6/Connect.js